export const RESYNC_PLC_SECURITIES = 'RESYNC_PLC_SECURITIES';
export const RESYNC_PLC_SECURITIES_SUCCESSFUL = 'RESYNC_PLC_SECURITIES_SUCCESSFUL';
export const RESYNC_PLC_SECURITIES_FAILED = 'RESYNC_PLC_SECURITIES_FAILED';
